import script from "./audit-trail-report.vue?vue&type=script&setup=true&lang=js"
export * from "./audit-trail-report.vue?vue&type=script&setup=true&lang=js"

import "./audit-trail-report.vue?vue&type=style&index=0&id=5212d496&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5212d496"]])

export default __exports__